export const userRoleItems = ["ADMIN", "COURIER", "CUSTOMER"];
export const sortItems = ["asc", "desc"];
export const uploadTypeItems = [
  "OTHERS",
  "AVATAR",
  "TICKETS",
  "DOCUMENTS",
  "PASS",
];
export const bulkSMSTypeItems = ["ALL", "CUSTOM"];
export const smsToken = {
  firstName: "{{firstName}}",
  lastName: "{{lastName}}",
  nationalNumber: "{{nationalNumber}}",
  address: "{{address}}",
};

//* Start Convert To Text
export const convertSortToText = (type) => {
  let result = "";
  switch (type) {
    case sortItems[0]:
      result = "صعودی";
      break;
    case sortItems[1]:
      result = "نزولی";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertRoleToText = (type) => {
  let result = "";
  switch (type) {
    case userRoleItems[0]:
      result = "ادمین";
      break;
    case userRoleItems[1]:
      result = "پیک";
      break;
    case userRoleItems[2]:
      result = "مشتری";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertBulkSMSTypeToText = (type) => {
  switch (type) {
    case bulkSMSTypeItems[0]:
      return "کاربران فعال";
    case bulkSMSTypeItems[1]:
      return "سفارشی";
    default:
      return type;
  }
};
//* End Convert To Text

//* Start Convert To Path
export const convertRoleToPath = (type) => {
  let result = "";
  switch (type) {
    case userRoleItems[0]:
      result = "admin";
      break;
    case userRoleItems[1]:
      result = "courier";
      break;
    case userRoleItems[2]:
      result = "customer";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
//* End Convert To Path

//* Start Data Exporter
export const exporterData = {
  users: {
    headers: [
      "نام",
      "نام خانوادگی",
      "کد ملی",
      "شماره موبایل",
      "ایمیل",
      "آدرس",
      "تایید ایمیل",
      "تایید شماره موبایل",
      "نقش کاربر",
      "تایید شده",
      "تاریخ ایجاد",
      "تاریخ آخرین ویرایش",
    ],
    keys: [
      "firstName",
      "lastName",
      "nationalNumber",
      "phoneNumber",
      "email",
      "address",
      "emailVerified",
      "phoneNumberVerified",
      "role",
      "isConfirm",
      "createdAt",
      "updatedAt",
    ],
    fileName: "users",
  },
  orders: {
    headers: [
      "کد پیگیری",
      "نام مشتری",
      "نام خانوادگی مشتری",
      "شماره همراه مشتری",
      "کد ملی مشتری",
      "آدرس مشتری",
      "نام پیک",
      "نام خانوادگی پیک",
      "شماره همراه پیک",
      "تاریخ ثبت",
      "وضعیت پیامک",
    ],
    keys: [
      "trackingCode",
      "customer.firstName",
      "customer.lastName",
      "customer.phoneNumber",
      "customer.nationalNumber",
      "customer.address",
      "courier.firstName",
      "courier.lastName",
      "courier.phoneNumber",
      "createdAt",
      "isSendSMS",
    ],
    fileName: "orders",
  },
  bulkSMSs: {
    headers: [
      "عنوان",
      "پیام",
      "نوع",
      "توضیحات",
      "تاریخ ایجاد",
      "تاریخ آخرین ویرایش",
    ],
    keys: ["title", "message", "type", "description", "createdAt", "updatedAt"],
    fileName: "bulkSMSs",
  },
};
//* End Data Exporter
